var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeshboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 768,
    viewBox: "0 0 1440 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2923_51892)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 768,
    fill: "#F8FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.029 843.793C499.932 843.793 496.703 842.195 497.022 840.325L523.698 683.852H549.26L511.604 840.926C511.212 842.558 508.202 843.793 504.616 843.793",
    fill: "#C6B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1092.97 843.793C1097.07 843.793 1100.3 842.195 1099.98 840.325L1073.3 683.852H1047.74L1085.4 840.926C1085.79 842.558 1088.8 843.793 1092.38 843.793",
    fill: "#C6B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.42 683.852H508.579C506.474 683.852 504.504 683.377 503.313 682.583C500.397 680.642 503.433 678 508.579 678H1088.42C1093.57 678 1096.6 680.642 1093.69 682.583C1092.5 683.377 1090.53 683.852 1088.42 683.852Z",
    fill: "#D6C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1074.15 687.752H522.846L523.697 683.852H1073.3L1074.15 687.752Z",
    fill: "#BAA2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.99 678H977.378C975.38 678 973.695 676.486 973.448 674.469L965.96 613.494V597.368H1021.41V613.494L1013.92 674.469C1013.67 676.486 1011.99 678 1009.99 678Z",
    fill: "#F9DCC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.99 678C1011.99 678 1013.67 676.486 1013.92 674.469L1021.41 613.494V597.368H965.96V613.494H1005.04C1006.18 613.494 1007.26 613.991 1008.01 614.858C1008.76 615.725 1009.11 616.878 1008.97 618.026L1002.04 674.469C1001.79 676.486 1000.11 678 998.108 678H1009.99Z",
    fill: "#F6CBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.45 597.368V601.4H969.92V597.368L972.786 591.533C973.457 590.168 974.828 589.305 976.329 589.305H1011.04C1012.54 589.305 1013.91 590.168 1014.58 591.533L1017.45 597.368Z",
    fill: "#653430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.58 591.533C1013.91 590.168 1012.54 589.305 1011.04 589.305H997.644C999.832 589.303 1001.61 591.109 1001.61 593.336C1001.61 595.564 999.832 597.37 997.644 597.368V601.4H1017.45V597.368L1014.58 591.533Z",
    fill: "#3E190C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.96 597.368H1021.41C1023.59 597.368 1025.37 599.173 1025.37 601.4V609.463C1025.37 611.69 1023.59 613.494 1021.41 613.494H965.96C963.773 613.494 962 611.69 962 609.463V601.4C962 599.173 963.773 597.368 965.96 597.368Z",
    fill: "#7C534F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.45 657.842H969.92L965.96 625.589H1021.41L1017.45 657.842Z",
    fill: "#B77B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.6 657.842H1017.45L1021.41 625.589H1005.56L1001.6 657.842Z",
    fill: "#AA644A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.41 597.368H1001.6C1003.79 597.368 1005.56 599.173 1005.56 601.4V609.463C1005.56 611.69 1003.79 613.494 1001.6 613.494H1021.41C1023.59 613.494 1025.37 611.69 1025.37 609.463V601.4C1025.37 599.173 1023.59 597.368 1021.41 597.368Z",
    fill: "#653430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.881 597.368C976.069 597.368 977.842 599.173 977.842 601.4V609.463C977.842 611.69 976.069 613.494 973.881 613.494C971.693 613.494 969.92 611.69 969.92 609.463V601.4C969.92 599.173 971.693 597.368 973.881 597.368Z",
    fill: "#93716E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993.604 584.63C992.988 584.63 992.489 584.122 992.489 583.495C992.489 583.195 992.607 582.906 992.816 582.693L993.317 582.183C994.169 581.316 994.168 579.91 993.316 579.044C993.214 578.94 993.103 578.847 992.983 578.766C990.957 577.39 990.411 574.603 991.763 572.541C991.924 572.295 992.109 572.066 992.314 571.857L992.816 571.346C993.243 570.896 993.949 570.883 994.392 571.318C994.835 571.754 994.847 572.472 994.419 572.923C994.41 572.932 994.401 572.942 994.392 572.951L993.89 573.462C993.039 574.329 993.04 575.734 993.891 576.6C993.993 576.704 994.105 576.797 994.225 576.878C996.25 578.254 996.797 581.042 995.445 583.104C995.284 583.349 995.099 583.578 994.894 583.787L994.392 584.298C994.183 584.511 993.899 584.63 993.604 584.63Z",
    fill: "#C7CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.29 584.63C999.676 584.63 999.178 584.122 999.178 583.495C999.178 583.195 999.295 582.906 999.504 582.693L1000.01 582.183C1000.86 581.316 1000.86 579.91 1000 579.044C999.903 578.94 999.791 578.847 999.671 578.766C997.646 577.39 997.099 574.603 998.451 572.541C998.612 572.295 998.797 572.066 999.002 571.857L999.504 571.346C999.932 570.896 1000.64 570.883 1001.08 571.319C1001.52 571.754 1001.54 572.472 1001.11 572.923C1001.1 572.933 1001.09 572.942 1001.08 572.951L1000.58 573.461C999.727 574.329 999.728 575.734 1000.58 576.6C1000.68 576.704 1000.79 576.797 1000.91 576.878C1002.94 578.254 1003.48 581.042 1002.13 583.104C1001.97 583.349 1001.79 583.578 1001.58 583.787L1001.08 584.298C1000.87 584.511 1000.59 584.63 1000.29 584.63Z",
    fill: "#C7CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.916 584.63C986.3 584.63 985.801 584.122 985.801 583.495C985.801 583.195 985.919 582.906 986.128 582.693L986.629 582.183C987.481 581.316 987.48 579.91 986.628 579.044C986.526 578.94 986.415 578.847 986.295 578.766C984.269 577.39 983.723 574.603 985.075 572.541C985.236 572.295 985.421 572.066 985.626 571.857L986.128 571.346C986.555 570.896 987.261 570.883 987.704 571.318C988.147 571.754 988.159 572.472 987.731 572.923C987.722 572.932 987.713 572.942 987.704 572.951L987.202 573.462C986.351 574.329 986.352 575.734 987.203 576.6C987.305 576.704 987.417 576.797 987.537 576.878C989.562 578.254 990.109 581.042 988.757 583.104C988.596 583.349 988.411 583.578 988.206 583.787L987.704 584.298C987.495 584.511 987.212 584.63 986.916 584.63Z",
    fill: "#C7CCD1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M992.76 616.95H994.05V624H992.76V616.95Z",
    fill: "#3E190C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.96 672.09C980.267 672.09 979.66 671.943 979.14 671.65C978.627 671.35 978.23 670.927 977.95 670.38C977.677 669.833 977.54 669.197 977.54 668.47C977.54 667.743 977.677 667.11 977.95 666.57C978.23 666.023 978.627 665.603 979.14 665.31C979.66 665.01 980.267 664.86 980.96 664.86C981.433 664.86 981.88 664.933 982.3 665.08C982.72 665.227 983.073 665.433 983.36 665.7L982.93 666.64C982.61 666.387 982.293 666.203 981.98 666.09C981.667 665.97 981.333 665.91 980.98 665.91C980.3 665.91 979.773 666.13 979.4 666.57C979.033 667.01 978.85 667.643 978.85 668.47C978.85 669.303 979.033 669.94 979.4 670.38C979.773 670.82 980.3 671.04 980.98 671.04C981.333 671.04 981.667 670.983 981.98 670.87C982.293 670.75 982.61 670.563 982.93 670.31L983.36 671.25C983.073 671.517 982.72 671.723 982.3 671.87C981.88 672.017 981.433 672.09 980.96 672.09ZM986.56 672.08C986.06 672.08 985.62 671.977 985.24 671.77C984.866 671.563 984.576 671.267 984.37 670.88C984.163 670.493 984.06 670.043 984.06 669.53C984.06 669.017 984.163 668.57 984.37 668.19C984.576 667.803 984.866 667.507 985.24 667.3C985.62 667.093 986.06 666.99 986.56 666.99C987.06 666.99 987.496 667.093 987.87 667.3C988.25 667.507 988.54 667.803 988.74 668.19C988.946 668.57 989.05 669.017 989.05 669.53C989.05 670.043 988.946 670.493 988.74 670.88C988.54 671.267 988.25 671.563 987.87 671.77C987.496 671.977 987.06 672.08 986.56 672.08ZM986.55 671.11C986.956 671.11 987.266 670.977 987.48 670.71C987.693 670.443 987.8 670.05 987.8 669.53C987.8 669.017 987.693 668.627 987.48 668.36C987.266 668.087 986.96 667.95 986.56 667.95C986.16 667.95 985.85 668.087 985.63 668.36C985.416 668.627 985.31 669.017 985.31 669.53C985.31 670.05 985.416 670.443 985.63 670.71C985.843 670.977 986.15 671.11 986.55 671.11ZM994.802 664.95V672H993.562V671.21C993.415 671.483 993.202 671.697 992.922 671.85C992.648 672.003 992.335 672.08 991.982 672.08C991.562 672.08 991.185 671.973 990.852 671.76C990.525 671.547 990.268 671.247 990.082 670.86C989.902 670.467 989.812 670.017 989.812 669.51C989.812 669.003 989.902 668.56 990.082 668.18C990.268 667.8 990.525 667.507 990.852 667.3C991.178 667.093 991.555 666.99 991.982 666.99C992.335 666.99 992.648 667.063 992.922 667.21C993.195 667.357 993.405 667.563 993.552 667.83V664.95H994.802ZM992.312 671.11C992.712 671.11 993.018 670.973 993.232 670.7C993.452 670.427 993.562 670.037 993.562 669.53C993.562 669.023 993.452 668.637 993.232 668.37C993.018 668.097 992.715 667.96 992.322 667.96C991.922 667.96 991.612 668.093 991.392 668.36C991.172 668.627 991.062 669.01 991.062 669.51C991.062 670.017 991.172 670.41 991.392 670.69C991.612 670.97 991.918 671.11 992.312 671.11ZM996.088 667.11H997.338V672H996.088V667.11ZM997.398 664.84V666.07H996.018V664.84H997.398ZM1001.47 666.99C1002.05 666.99 1002.49 667.157 1002.78 667.49C1003.06 667.823 1003.21 668.327 1003.21 669V672H1001.96V669.07C1001.96 668.69 1001.88 668.413 1001.74 668.24C1001.6 668.067 1001.37 667.98 1001.07 667.98C1000.71 667.98 1000.42 668.093 1000.2 668.32C999.983 668.547 999.877 668.85 999.877 669.23V672H998.627V667.11H999.847V667.84C1000.01 667.567 1000.24 667.357 1000.52 667.21C1000.8 667.063 1001.11 666.99 1001.47 666.99ZM1009.24 667.11V671.55C1009.24 672.317 1009.02 672.897 1008.6 673.29C1008.18 673.683 1007.55 673.88 1006.73 673.88C1006.3 673.88 1005.89 673.823 1005.5 673.71C1005.1 673.603 1004.76 673.45 1004.47 673.25L1004.82 672.37C1005.42 672.737 1006.05 672.92 1006.7 672.92C1007.56 672.92 1008 672.493 1008 671.64V671C1007.85 671.273 1007.64 671.487 1007.36 671.64C1007.08 671.787 1006.76 671.86 1006.4 671.86C1005.97 671.86 1005.59 671.76 1005.26 671.56C1004.93 671.353 1004.67 671.067 1004.49 670.7C1004.3 670.333 1004.21 669.91 1004.21 669.43C1004.21 668.95 1004.3 668.527 1004.48 668.16C1004.66 667.787 1004.92 667.5 1005.26 667.3C1005.59 667.093 1005.97 666.99 1006.4 666.99C1006.76 666.99 1007.08 667.067 1007.36 667.22C1007.64 667.367 1007.85 667.577 1008 667.85V667.11H1009.24ZM1006.73 670.89C1007.13 670.89 1007.44 670.76 1007.66 670.5C1007.88 670.24 1008 669.883 1008 669.43C1008 668.97 1007.88 668.61 1007.66 668.35C1007.44 668.09 1007.13 667.96 1006.73 667.96C1006.33 667.96 1006.02 668.09 1005.8 668.35C1005.57 668.61 1005.46 668.97 1005.46 669.43C1005.46 669.877 1005.57 670.233 1005.8 670.5C1006.02 670.76 1006.33 670.89 1006.73 670.89Z",
    fill: "#3E190C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.45 635.878C1003.56 634.713 1002.31 633.881 1000.89 633.514C999.476 633.146 997.978 633.266 996.637 633.853C995.438 634.371 994.368 635.243 993.5 636.402C992.632 635.241 991.562 634.368 990.363 633.853C989.022 633.266 987.524 633.146 986.107 633.514C984.691 633.881 983.439 634.713 982.553 635.878C981.618 637.102 981.124 638.633 981.124 640.303C981.124 642.707 982.558 645.344 985.385 648.144C987.688 650.425 990.41 652.293 991.827 653.204C992.327 653.523 992.907 653.693 993.5 653.693C994.093 653.693 994.673 653.523 995.173 653.204C996.589 652.293 999.312 650.425 1001.62 648.144C1004.44 645.345 1005.88 642.707 1005.88 640.303C1005.88 638.633 1005.38 637.102 1004.45 635.878Z",
    fill: "#F7D9CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.326 738.263C438.326 738.263 477.772 690.3 467.666 681.383C457.559 672.465 427.835 715.863 425.457 736.671C423.079 757.478 438.326 738.263 438.326 738.263Z",
    fill: "#7AC143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.192 742.021C386.814 739.643 327.959 657.008 342.227 639.173C356.495 621.339 404.886 728.269 402.984 736.929C401.082 745.588 389.192 742.021 389.192 742.021Z",
    fill: "#5E9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.378 740.238C412.378 740.238 414.756 635.012 438.535 626.095C462.315 617.178 444.405 664.017 438.535 689.96C432.666 715.903 422.484 749.966 422.484 749.966L412.378 740.238Z",
    fill: "#4F871F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.951 652.251C380.226 671.392 389.691 700.407 401.49 744.369C401.987 746.206 402.483 748.071 402.985 749.964H422.482C421.161 709.371 420.013 699.816 420.013 699.816C418.748 689.273 416.278 674.663 411.19 658.197C405.398 639.463 396.055 609.226 383.047 609.001C379.809 608.945 376.819 610.758 374.364 613.172C371.974 615.514 370.091 618.434 368.98 620.744C363.226 632.711 369.472 646.52 371.951 652.251Z",
    fill: "#7AC143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.951 652.251C380.226 671.393 389.691 700.407 401.49 744.369C403.205 746.173 405.033 748.085 406.841 749.964C413.298 756.679 419.512 763.037 419.512 763.037L415.215 749.964L412.553 741.867C412.394 741.876 385.071 635.804 374.364 613.172C371.974 615.515 370.091 618.434 368.98 620.744C363.226 632.712 369.472 646.521 371.951 652.251Z",
    fill: "#67AF32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.611 778.285C383.759 779.475 430.809 785.421 436.751 778.285C437.083 777.887 437.421 777.39 437.758 776.804C443.428 766.945 449.351 732.514 447.266 733.329C426.859 741.286 377.302 732.509 371.52 733.329C370.976 733.404 370.62 733.854 370.433 734.608C368.563 741.853 381.571 777.207 382.611 778.285Z",
    fill: "#E2EEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.631 744.776C424.951 744.776 440.173 742.609 440.42 742.573C440.804 742.517 441.07 742.161 441.014 741.776C440.959 741.392 440.602 741.126 440.218 741.182C439.821 741.24 400.257 746.869 376.311 739.861C375.938 739.752 375.548 739.965 375.439 740.338C375.33 740.71 375.544 741.101 375.916 741.21C385.224 743.934 396.835 744.776 407.631 744.776Z",
    fill: "#D3E3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.611 778.285C383.759 779.475 430.809 785.421 436.751 778.285C437.083 777.886 437.421 777.39 437.758 776.804C423.949 780.018 391.669 783.678 377.897 751.234C375.011 744.43 372.541 738.971 370.433 734.608C368.563 741.853 381.571 777.207 382.611 778.285Z",
    fill: "#D3E3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.75 582.993L526.221 582L533.573 644.713L525.101 645.706L517.75 582.993Z",
    fill: "#F7A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.745 582.993L526.216 582L526.964 588.379L518.492 589.372L517.745 582.993Z",
    fill: "#4B9E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.026 593.868L549.506 594.79L542.68 657.563L534.2 656.641L541.026 593.868Z",
    fill: "#E68080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.026 593.868L549.506 594.79L548.811 601.176L540.332 600.253L541.026 593.868Z",
    fill: "#396196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.672 678H520.549L515 625.693H560.222L554.672 678Z",
    fill: "#8568D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 625.693L515.102 626.654H549.555L544.108 678H554.672L560.222 625.693H515Z",
    fill: "#8568D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.059 623.508C599.593 623.508 594.333 618.247 594.333 611.782C594.333 605.316 599.594 600.057 606.059 600.057H672.34V623.508H606.059Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.179 627.565H606.059C597.342 627.565 590.277 620.499 590.277 611.783C590.277 603.066 597.343 596.001 606.059 596.001H676.179V627.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M601.771 608.145H672.34M601.771 615.306H672.34M606.059 623.508C599.593 623.508 594.333 618.247 594.333 611.782C594.333 605.316 599.594 600.057 606.059 600.057H672.34V623.508H606.059Z",
    stroke: "#B1B4BA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.059 623.508C599.593 623.508 594.334 618.247 594.334 611.782C594.334 605.316 599.594 600.057 606.059 600.057H673.475L676.179 596H606.059C597.342 596 590.277 603.066 590.277 611.782C590.277 620.498 597.343 627.564 606.059 627.564H676.179L673.475 623.507L606.059 623.508Z",
    fill: "#D75757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.967 653.633H540.571C539.359 653.633 538.196 653.152 537.339 652.294C536.482 651.437 536 650.274 536 649.062V632.136C536 630.923 536.482 629.761 537.339 628.903C538.196 628.046 539.359 627.564 540.571 627.564H668.967C670.179 627.564 671.342 628.046 672.199 628.903C673.056 629.761 673.538 630.923 673.538 632.136V649.061C673.538 649.662 673.42 650.256 673.19 650.811C672.96 651.366 672.624 651.87 672.199 652.294C671.775 652.719 671.271 653.055 670.716 653.285C670.161 653.515 669.567 653.633 668.967 653.633Z",
    fill: "#394460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.108 658.867H556.399C557.266 661.065 557.772 663.705 557.772 666.546C557.772 669.388 557.266 672.028 556.399 674.226H705.108C704.241 672.028 703.735 669.388 703.735 666.546C703.736 663.705 704.241 661.065 705.108 658.867Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.371 654.78H709.141V658.867H552.371V654.78Z",
    fill: "#504DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.371 674.226H709.141V678.312H552.371V674.226Z",
    fill: "#F6F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.371 674.226H709.141V678.312H552.371V674.226Z",
    fill: "#504DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.057 663.557H703.736M558.057 668.976H703.736M705.108 658.867H556.399C557.266 661.065 557.772 663.705 557.772 666.546C557.772 669.388 557.266 672.028 556.399 674.226H705.108C704.241 672.028 703.735 669.388 703.735 666.546C703.736 663.705 704.241 661.065 705.108 658.867Z",
    stroke: "#ECEDEE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.559 630.437C557.737 630.441 556.952 630.511 556.261 630.633C554.226 630.992 553.856 631.745 553.856 633.133V634.966H558.665V635.576H553.856H552.052C550.654 635.576 549.43 636.417 549.047 638.015C548.606 639.846 548.586 640.99 549.047 642.902C549.389 644.326 550.205 645.34 551.603 645.34H553.257V643.143C553.257 641.556 554.63 640.156 556.261 640.156H561.064C562.401 640.156 563.469 639.055 563.469 637.712V633.133C563.469 631.829 562.369 630.85 561.064 630.633C560.238 630.495 559.381 630.433 558.559 630.437ZM555.958 631.911C556.455 631.911 556.861 632.323 556.861 632.83C556.861 633.335 556.455 633.744 555.958 633.744C555.46 633.744 555.056 633.335 555.056 632.83C555.056 632.323 555.46 631.911 555.958 631.911Z",
    fill: "url(#paint0_linear_2923_51892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.069 635.576V637.712C564.069 639.367 562.665 640.761 561.064 640.761H556.261C554.945 640.761 553.856 641.887 553.856 643.205V647.784C553.856 649.087 554.99 649.854 556.261 650.228C557.783 650.675 559.243 650.756 561.064 650.228C562.275 649.877 563.469 649.172 563.469 647.784V645.951H558.665V645.34H563.469H565.874C567.271 645.34 567.792 644.365 568.278 642.902C568.78 641.395 568.759 639.947 568.278 638.014C567.933 636.623 567.273 635.576 565.874 635.576H564.069V635.576ZM561.367 647.173C561.866 647.173 562.27 647.581 562.27 648.087C562.27 648.593 561.866 649.006 561.367 649.006C560.87 649.006 560.465 648.593 560.465 648.087C560.465 647.581 560.87 647.173 561.367 647.173Z",
    fill: "url(#paint1_linear_2923_51892)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    filter: "url(#filter0_f_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632 570.334H648.265V611.621H632V570.334Z",
    fill: "#1F3969"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    filter: "url(#filter1_f_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.55 611.621H632V624.883C632 633.217 638.756 639.972 647.088 639.972H664.518C664.52 639.894 664.529 639.819 664.529 639.74V617.6C664.529 616.015 663.899 614.494 662.778 613.372C661.657 612.251 660.136 611.621 658.55 611.621Z",
    fill: "#1F3969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M813.047 659.12L810.381 629.359H766.687L764.022 659.12C763.402 666.033 759.242 672.656 752.722 677.936L752.714 678H824.355L824.347 677.936C817.826 672.656 813.666 666.033 813.047 659.12Z",
    fill: "#BFCFE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M768.122 629.632L766.644 647.319H809.978L808.5 629.632H768.122Z",
    fill: "#1F3969",
    stroke: "#1F3969",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.266 633.782H648.803C642.942 633.782 638.191 629.03 638.191 623.169V440.988C638.191 435.127 642.942 430.375 648.803 430.375H928.266C934.127 430.375 938.879 435.127 938.879 440.988V623.169C938.879 629.031 934.127 633.782 928.266 633.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.266 633.782H648.803C642.942 633.782 638.191 629.03 638.191 623.169V440.988C638.191 435.127 642.942 430.375 648.803 430.375H928.266C934.127 430.375 938.879 435.127 938.879 440.988V623.169C938.879 629.031 934.127 633.782 928.266 633.782Z",
    fill: "url(#paint2_linear_2923_51892)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M923.844 445.409V599.813H653.225V445.409H923.844Z",
    fill: "#F6F9FD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    filter: "url(#filter3_f_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663 463V554.706C663 556.11 663.559 557.457 664.554 558.45C665.549 559.442 666.898 560 668.305 560H793.695C795.102 560 796.451 559.442 797.446 558.45C798.441 557.457 799 556.11 799 554.706V463H663Z",
    fill: "#071323"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M776.643 616.715H800.426",
    stroke: "#1F3969",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    filter: "url(#filter4_f_2923_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.88 582H840.12C838.497 582 836.94 581.351 835.793 580.196C834.645 579.04 834 577.473 834 575.839V481.161C834 479.527 834.645 477.96 835.793 476.804C836.94 475.649 838.497 475 840.12 475H928.88C930.503 475 932.06 475.649 933.207 476.804C934.355 477.96 935 479.527 935 481.161V575.839C935 577.473 934.355 579.04 933.207 580.196C932.06 581.351 930.503 582 928.88 582Z",
    fill: "#1F3969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M845.212 550.29H678C676.123 550.29 674.324 549.544 672.997 548.218C671.67 546.891 670.925 545.091 670.925 543.215V412.075C670.925 410.199 671.67 408.399 672.997 407.072C674.324 405.745 676.123 405 678 405H845.211C847.087 405 848.887 405.745 850.214 407.072C851.54 408.399 852.286 410.199 852.286 412.075V543.216C852.286 544.145 852.103 545.065 851.747 545.923C851.392 546.781 850.871 547.561 850.214 548.218C849.557 548.875 848.777 549.396 847.919 549.752C847.061 550.107 846.141 550.29 845.212 550.29Z",
    fill: "#111D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.287 425.574H670.925V412.075C670.925 410.199 671.67 408.399 672.997 407.072C674.324 405.745 676.123 405 678 405H845.211C847.087 405 848.887 405.745 850.213 407.072C851.54 408.399 852.286 410.199 852.286 412.075L852.287 425.574Z",
    fill: "#E7EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.676 418.825C690.63 418.825 692.213 417.241 692.213 415.288C692.213 413.334 690.63 411.75 688.676 411.75C686.722 411.75 685.138 413.334 685.138 415.288C685.138 417.241 686.722 418.825 688.676 418.825Z",
    fill: "#E03934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.956 418.825C702.91 418.825 704.494 417.241 704.494 415.288C704.494 413.334 702.91 411.75 700.956 411.75C699.003 411.75 697.419 413.334 697.419 415.288C697.419 417.241 699.003 418.825 700.956 418.825Z",
    fill: "#FBDB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.237 418.825C715.191 418.825 716.774 417.241 716.774 415.288C716.774 413.334 715.191 411.75 713.237 411.75C711.283 411.75 709.699 413.334 709.699 415.288C709.699 417.241 711.283 418.825 713.237 418.825Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.214 441.9H709.7M715.006 529.064H753.085",
    stroke: "#9169FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.116 441.9H786.549",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.774 441.9H766.632",
    stroke: "#7BFFA0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.214 529.063H704.493",
    stroke: "#7BFFA0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.633 452.796H773.721",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.026 452.796H758.105",
    stroke: "#9169FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.957 452.796H725.493",
    stroke: "#FFC47D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.935 463.691H760.017",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.35 463.691H732.233",
    stroke: "#FF5757",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.747 474.587H746.114",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.218 474.587H734.026",
    stroke: "#9169FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.957 474.587H716.775",
    stroke: "#7BFFA0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.918 485.482H763.125",
    stroke: "#FFC47D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.957 485.482H726.274",
    stroke: "#FF5757",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.547 496.378H782.884",
    stroke: "#9169FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.918 496.378H759.459",
    stroke: "#FF5757",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.35 496.378H726.274",
    stroke: "#7BFFA0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.066 507.273H759.459",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.35 507.273H736.886",
    stroke: "#9169FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.833 518.168H796.125",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.026 518.168H772.558",
    stroke: "#FFC47D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.957 518.168H725.493",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.549 587.406H850.796C849.118 587.406 847.508 586.739 846.322 585.553C845.135 584.366 844.469 582.757 844.469 581.079V483.846C844.469 482.167 845.135 480.558 846.322 479.372C847.508 478.185 849.118 477.519 850.796 477.519H942.549C944.227 477.519 945.837 478.185 947.023 479.372C948.21 480.558 948.876 482.167 948.876 483.846V581.079C948.876 582.757 948.21 584.366 947.023 585.553C945.837 586.739 944.227 587.406 942.549 587.406Z",
    fill: "#62ADE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.896 507.63H864.386C863.302 507.63 862.263 507.199 861.496 506.433C860.73 505.666 860.3 504.627 860.3 503.543V497.375C860.3 496.291 860.73 495.251 861.496 494.485C862.263 493.719 863.302 493.288 864.386 493.288H928.896C929.98 493.288 931.02 493.719 931.786 494.485C932.552 495.251 932.983 496.291 932.983 497.375V503.543C932.983 504.627 932.552 505.666 931.786 506.433C931.02 507.199 929.98 507.63 928.896 507.63ZM900.547 530.808H864.449C863.913 530.808 863.381 530.702 862.885 530.497C862.39 530.291 861.939 529.99 861.56 529.611C861.18 529.231 860.879 528.781 860.674 528.285C860.469 527.789 860.363 527.258 860.363 526.721V520.553C860.363 520.016 860.469 519.484 860.674 518.989C860.879 518.493 861.18 518.042 861.56 517.663C861.939 517.284 862.39 516.983 862.885 516.777C863.381 516.572 863.913 516.466 864.449 516.466H900.547C901.631 516.466 902.67 516.897 903.436 517.663C904.203 518.429 904.633 519.469 904.633 520.553V526.721C904.633 527.805 904.203 528.844 903.436 529.611C902.67 530.377 901.631 530.808 900.547 530.808ZM928.96 530.808H914.997C913.913 530.808 912.874 530.377 912.107 529.611C911.341 528.844 910.91 527.805 910.91 526.721V520.553C910.91 519.469 911.341 518.429 912.107 517.663C912.874 516.897 913.913 516.466 914.997 516.466H928.96C930.043 516.466 931.083 516.897 931.849 517.663C932.616 518.429 933.046 519.469 933.046 520.553V526.721C933.046 527.805 932.616 528.844 931.849 529.611C931.083 530.377 930.043 530.808 928.96 530.808Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.3 554.89H932.983M860.3 563.424H932.983M860.3 571.957H904.57",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 221.642C535.58 221.642 550.642 206.58 550.642 188C550.642 169.42 535.58 154.357 517 154.357C498.42 154.357 483.357 169.42 483.357 188C483.357 206.58 498.42 221.642 517 221.642Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 217.902C533.515 217.902 546.902 204.514 546.902 188C546.902 171.485 533.515 158.098 517 158.098C500.486 158.098 487.098 171.485 487.098 188C487.098 204.514 500.486 217.902 517 217.902Z",
    fill: "#F3F6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.08 188.71H512.99C512.609 188.71 512.302 188.402 512.302 188.022C512.302 187.642 512.609 187.334 512.99 187.334H530.08C530.46 187.334 530.767 187.642 530.767 188.022C530.767 188.402 530.46 188.71 530.08 188.71Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.993 192.294C516.804 192.294 516.649 192.141 516.649 191.951V163.931C516.649 163.741 516.804 163.587 516.993 163.587C517.183 163.587 517.337 163.741 517.337 163.931V191.951C517.337 192.141 517.183 192.294 516.993 192.294Z",
    fill: "#FE4C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.915 201.915C505.839 201.915 505.761 201.889 505.697 201.837C505.55 201.717 505.528 201.5 505.649 201.353L519.333 184.623C519.453 184.475 519.672 184.453 519.817 184.574C519.965 184.694 519.986 184.911 519.865 185.058L506.181 201.788C506.114 201.872 506.014 201.915 505.915 201.915Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.994 189.184C517.621 189.184 518.129 188.676 518.129 188.049C518.129 187.421 517.621 186.913 516.994 186.913C516.367 186.913 515.858 187.421 515.858 188.049C515.858 188.676 516.367 189.184 516.994 189.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.896 187.999C546.896 204.521 533.511 217.907 517.002 217.907C505.268 217.907 495.115 211.152 490.218 201.33C495.707 207.947 503.988 212.17 513.26 212.17C529.769 212.17 543.168 198.771 543.168 182.263C543.168 177.503 542.054 172.99 540.059 168.987C544.337 174.16 546.896 180.777 546.896 187.999Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.577 -0.145508H911.417V45.0286H914.577V-0.145508Z",
    fill: "#4A5258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.74 55.768H904.254L908.842 45.0303H917.153L921.74 55.768Z",
    fill: "#3A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.965 89.0442H868.035L892.637 66.4216L904.221 55.7646H921.779L957.965 89.0442Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.614 89.0449C925.331 91.7899 924.161 94.2722 922.364 96.1893C920.104 98.6313 916.875 100.145 913.282 100.145C907.914 100.145 903.353 96.7343 901.637 91.9308C901.294 91.0227 901.073 90.054 900.972 89.0449H925.614Z",
    fill: "#FFCF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.614 89.0449C925.331 91.7899 924.161 94.2722 922.364 96.1893C921.375 95.3621 920.305 94.6757 919.176 94.0904C915.341 92.1126 910.941 91.3858 906.602 91.406C904.947 91.406 903.252 91.5272 901.637 91.9308C901.294 91.0227 901.073 90.054 900.972 89.0449H925.614Z",
    fill: "#EDBA3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.965 89.0454H956.875C936.794 78.2277 915.038 70.5994 892.636 66.4217L904.221 55.7656H921.779L957.965 89.0454Z",
    fill: "#D1DCF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2923_51892",
    x: 608,
    y: 546.334,
    width: 64.2646,
    height: 89.2871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2923_51892"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2923_51892",
    x: 608,
    y: 587.621,
    width: 80.5291,
    height: 76.3506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2923_51892"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2923_51892",
    x: 638.191,
    y: 430.375,
    width: 304.688,
    height: 208.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.784314 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2923_51892"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2923_51892",
    x: 639,
    y: 439,
    width: 184,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2923_51892"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2923_51892",
    x: 810,
    y: 451,
    width: 149,
    height: 155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2923_51892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2923_51892",
    x1: 548.237,
    y1: 631.01,
    x2: 559.329,
    y2: 640.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2923_51892",
    x1: 563.502,
    y1: 646.348,
    x2: 559.525,
    y2: 640.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2923_51892",
    x1: 788.535,
    y1: 430.375,
    x2: 788.535,
    y2: 633.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C4D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2923_51892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2923_51892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 15,
    fill: "white",
    transform: "translate(984 571)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2923_51892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.158,
    height: 20.158,
    fill: "white",
    transform: "translate(548.599 630.437)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeshboard);
export default __webpack_public_path__ + "static/media/deshboard.97ff625afecee37f18aea76ae9a81071.svg";
export { ForwardRef as ReactComponent };